<template>
  <div>
    <div v-for="item in internalItens" v-bind:key="item.id">
      <base-input
        type="text"
        :label="config.label"
        :placeholder="config.placeholder"
        :addonRightRemoveID="internalItens.length > 1 ? item.id : null"
        v-model="item.text"
        @input="returnList"
        @remove-input="removeInput"
      ></base-input>
    </div>
    <div class="col-md-12">
      <!-- <button
        class="btn btn-danger btn-fill float-left"
        @click="$router.push('wheel-play')"
      >
        Voltar
      </button>
      <button class="btn btn-base btn-fill float-right" @click="returnList">
        Salvar
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "itens",
    event: "return-list",
  },

  props: {
    config: Object,
    itens: Array,
  },

  data() {
    return {
      internalItens: [],
      maxMembers: 50,
    };
  },

  computed: {
    lastElement() {
      return this.internalItens[this.internalItens.length - 1];
    },
  },

  mounted() {
    this.internalItens = this.itens;
    this.internalItens.push({ id: this.internalItens.length + 1, text: "" });
  },

  watch: {
    internalItens: {
      deep: true,
      handler(internalItens) {
        // Add new element if the last element was setted
        if (
          this.lastElement.text !== "" &&
          internalItens.length < this.maxMembers
        ) {
          internalItens.push({ id: internalItens.length + 1, text: "" });
        }
      },
    },
  },

  methods: {
    removeInput(wheelOptionID) {
      this.internalItens.splice(wheelOptionID - 1, 1);
      this.returnList();
    },
    returnList() {
      this.$emit("return-list", this.internalItens);
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}
</style>
